import React from "react";
import ReactDOM from "react-dom";

function BuyingSheetModal(props) {
  return ReactDOM.createPortal(
    <React.Fragment>
      <div
        className={"modal fade " + (props.modal ? "show " : "")}
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={props.modal ? { display: "block" } : { display: "none" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header px-4 border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => props.setModal(false)}
              ></button>
            </div>
            <div className="modal-body py-0 pb-4">
              <div className="spacer-5"></div>
              <div className="row justify-content-center text-center gx-2">
                <div className="col-sm-6">
                  <a
                    href="/purchase-orderpdf.html"
                    className="btn btn-outline-lite btn-lg text-dark d-flex align-items-center justify-content-center px-4 fw-medium rounded-3 mx-1"
                    target="_blank"
                  >
                    Purchase Order
                  </a>
                </div>
                <div className="col-sm-6">
                  <a
                    href="/onhand-pdf.html"
                    className="btn btn-outline-lite btn-lg text-dark d-flex align-items-center px-4 justify-content-center fw-medium rounded-3 mx-1"
                    target="_blank"
                  >
                    Buying Sheet
                  </a>
                </div>
              </div>
              <div className="spacer-6"></div>
            </div>
          </div>
        </div>
      </div>
      {props.modal ? <div className="modal-backdrop fade show" /> : ""}
    </React.Fragment>,
    document.getElementById("modal-root")
  );
}
export default BuyingSheetModal;
